const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const images = {
  hero: u("1721222203415-69033eaf3bd1", 1800),
  heroDetail: u("1783685158361-a82d34288149", 900),
  villaArchitecture: u("1760067537524-a0c0703d9721", 1600),
  kitchen: u("1759147960461-b74a7e9a75d4", 1600),
  kitchenDark: u("1512916194211-3f2b7f5f7de3", 1400),
  kitchenLight: u("1643949915134-73a4c880f7c7", 1400),
  kitchenIsland: u("1684928365167-e91916573122", 1400),
  bedroom: u("1633944095397-878622ebc01c", 1400),
  bedroomWarm: u("1611892440504-42a792e24d32", 1400),
  bedroomCanopy: u("1737527852155-9720a5e2254f", 1400),
  bedroomSlat: u("1635247049915-dff57098ea0f", 1400),
  tvBackdrop: u("1745429523637-60f5986cc1db", 1400),
  texture: u("1783685158053-08213c96da9a", 1400),
  dining: u("1772442363851-738a548f6c5c", 1400),
  poolside: u("1675657144410-0f601cf4edbd", 1600),
  wardrobe: u("1751806524616-47dd4fabd68d", 1400),
  wardrobeMinimal: u("1785395407788-71b829c98bb4", 1400),
  restaurantTree: u("1636405189493-181ecf851006", 1600),
  restaurantWood: u("1670819917685-f1040e76b9b7", 1400),
  editorial: u("1783685158361-a82d34288149", 1400),
};
